import apiClient from './apiClient';

// ============================================================
// Types
// ============================================================

export interface QueryRequest {
  itemFrom: string;  // Product code range start (12 chars)
  itemTo: string;    // Product code range end (12 chars)
  dateFrom: string;  // Receipt date range start YYYY-MM-DD
  dateTo: string;    // Receipt date range end YYYY-MM-DD
}

export interface ReceiptCostRow {
  itemCode: string;
  finishName: string;
  receiptNo: string;
  qty: number;
  price: number;
  currency: string;
  seqNo: number;
  unit: string;
  supplier: string;
  receiptDt: string | null;
  source: string;    // 'purchase' or 'subcontract'
  amount: number;
}

export interface ItemSummary {
  itemCode: string;
  totalQty: number;
  totalAmt: number;
  rowCount: number;
}

export interface QueryResponse {
  details: ReceiptCostRow[];
  summaries: ItemSummary[];
  totalCount: number;
}

export interface LookupResult {
  code: string;
  name: string;
}

// ============================================================
// API Client
// ============================================================

export const d314Api = {
  async query(req: QueryRequest): Promise<QueryResponse> {
    const res = await apiClient.post('/api/d314/query', req);
    return res.data;
  },

  async lookup(type: string, code: string): Promise<LookupResult> {
    const res = await apiClient.get(`/api/d314/lookup/${type}/${encodeURIComponent(code)}`);
    return res.data;
  },
};
